module.exports = __webpack_public_path__ + "static/media/player_2.51c870ce.png";